require('./_wks-define')('asyncIterator');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.1@core-js/library/modules/es7.symbol.async-iterator.js
 ** module id = 499
 ** module chunks = 0
 **/